import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter, useRouteError, Navigate } from "react-router-dom";
import { lazy } from "react";
import { lazyRetry } from "./utils/lazyRetry";
import { HistoryProvider } from "./contexts/HistoryContext";
const MainPage = lazy(() => lazyRetry(() => import('./pages/main')));
const CoursePage = lazy(() => lazyRetry(() => import('./pages/course')));
const ConsultationPage = lazy(() => lazyRetry(() => import('./pages/consultation')));
const MentoringPage = lazy(() => lazyRetry(() => import('./pages/mentoring')));
const InterviewPage = lazy(() => lazyRetry(() => import('./pages/interview')));
const ReviewListPage = lazy(() => lazyRetry(() => import('./pages/reviewList')));
const OrganizationInfoPage = lazy(() => lazyRetry(() => import('./pages/organizationInfo')));
const SellPage = lazy(() => lazyRetry(() => import('./pages/sell')));
const RouteErrorBoundary = () => {
    const error = useRouteError();
    console.error('Routing error:', error);
    // Редиректим на главную при ошибке
    return _jsx(Navigate, { to: "/", replace: true });
};
export const appRouter = (isMobile) => {
    return createBrowserRouter([
        {
            errorElement: _jsx(RouteErrorBoundary, {}),
            children: [
                {
                    path: '/',
                    element: _jsx(HistoryProvider, { children: _jsx(MainPage, { isMobile: isMobile }) })
                },
                {
                    path: '/course',
                    element: _jsx(HistoryProvider, { children: _jsx(CoursePage, { isMobile: isMobile }) })
                },
                {
                    path: '/consultation',
                    element: _jsx(HistoryProvider, { children: _jsx(ConsultationPage, { isMobile: isMobile }) })
                },
                {
                    path: '/interview',
                    element: _jsx(HistoryProvider, { children: _jsx(InterviewPage, { isMobile: isMobile }) })
                },
                {
                    path: '/mentoring',
                    element: _jsx(HistoryProvider, { children: _jsx(MentoringPage, { isMobile: isMobile }) })
                },
                {
                    path: '/reviews',
                    element: _jsx(HistoryProvider, { children: _jsx(ReviewListPage, { isMobile: isMobile }) })
                },
                {
                    path: '/organization_info',
                    element: _jsx(HistoryProvider, { children: _jsx(OrganizationInfoPage, { isMobile: isMobile }) })
                },
                {
                    path: '/sell/:uuid',
                    element: _jsx(SellPage, { isMobile: isMobile })
                }
            ]
        }
    ]);
};
